/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreateExerciseLanguageDto } from './create-exercise-language-dto';
import { CreateExerciseSourceDto } from './create-exercise-source-dto';
import { CreateExerciseToolDto } from './create-exercise-tool-dto';
import { EnExerciseStatus } from './en-exercise-status';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateExerciseDto
 */
export interface CreateExerciseDto {

    /**
     * @type {string}
     * @memberof CreateExerciseDto
     */
    name: string;

    /**
     * @type {string}
     * @memberof CreateExerciseDto
     */
    orientation: CreateExerciseDtoOrientationEnum;

    /**
     * @type {string}
     * @memberof CreateExerciseDto
     */
    side: CreateExerciseDtoSideEnum;

    /**
     * @type {string}
     * @memberof CreateExerciseDto
     */
    position: CreateExerciseDtoPositionEnum;

    /**
     * @type {string}
     * @memberof CreateExerciseDto
     */
    direction: CreateExerciseDtoDirectionEnum;

    /**
     * @type {number}
     * @memberof CreateExerciseDto
     */
    rotation: number;

    /**
     * @type {number}
     * @memberof CreateExerciseDto
     */
    duration: number;

    /**
     * @type {boolean}
     * @memberof CreateExerciseDto
     */
    isStatic: boolean;

    /**
     * @type {EnExerciseStatus}
     * @memberof CreateExerciseDto
     */
    status?: EnExerciseStatus;

    /**
     * @type {string}
     * @memberof CreateExerciseDto
     */
    note: string;

    /**
     * @type {Array<CreateExerciseSourceDto | JoinEntityDto>}
     * @memberof CreateExerciseDto
     */
    sources: Array<CreateExerciseSourceDto | JoinEntityDto>;

    /**
     * @type {Array<CreateExerciseToolDto | JoinEntityDto>}
     * @memberof CreateExerciseDto
     */
    tools: Array<CreateExerciseToolDto | JoinEntityDto>;

    /**
     * @type {Array<CreateExerciseLanguageDto | JoinEntityDto>}
     * @memberof CreateExerciseDto
     */
    languages: Array<CreateExerciseLanguageDto | JoinEntityDto>;

    /**
     * @type {Array<JoinEntityDto>}
     * @memberof CreateExerciseDto
     */
    tags?: Array<JoinEntityDto>;
}

/**
 * @export
 * @enum {string}
 */
export enum CreateExerciseDtoOrientationEnum {
    VERTICAL = 'VERTICAL',
    HORIZONTAL = 'HORIZONTAL'
}
/**
 * @export
 * @enum {string}
 */
export enum CreateExerciseDtoSideEnum {
    LEFT = 'LEFT',
    RIGHT = 'RIGHT'
}
/**
 * @export
 * @enum {string}
 */
export enum CreateExerciseDtoPositionEnum {
    STANDING = 'STANDING',
    SEATED = 'SEATED',
    PRONE = 'PRONE',
    SUPINE = 'SUPINE',
    KNEELING = 'KNEELING'
}
/**
 * @export
 * @enum {string}
 */
export enum CreateExerciseDtoDirectionEnum {
    FRONTAL = 'FRONTAL',
    LATERAL = 'LATERAL',
    BEHIND = 'BEHIND'
}

